/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {TSMessageEvent} from '../../models/enums/TSErrorEvent';
import {IHasUnconnectedDocuments, isInstanceOfHasUnconnectedDocuments} from '../../models/IHasUnconnectedDocuments';
import TSAbstractEntity from '../../models/TSAbstractEntity';
import TSDokument from '../../models/TSDokument';
import TSExceptionReport from '../../models/TSExceptionReport';
import DVBernUtil from '../../utils/DVBernUtil';
import IFormController = angular.IFormController;
import IScope = angular.IScope;

export default class AbstractGesuchViewController<T extends TSAbstractEntity> {

    private _model: T;
    private _initialModel: T;
    form: IFormController;
    $scope: IScope;

    constructor($scope: IScope) {
        this.$scope = $scope;
    }

    $onInit() {
        /**
         * Wichtig: in SERF speichern wir auch Forms die nicht dirty sind. Daher ist dieses verhalten nicht relevant
         * und kann allenfalls ausgeschaltet werden.
         * Grund fuer diesen Code ist:
         * Wenn der Server einen Validation-Fehler zurueckgibt, wird der DirtyPlugin nicht informiert und setzt das Form
         * auf !dirty. Dann kann der Benutzer nochmal auf Speichern klicken und die Page wechselt ohne Fehler da der Client
         * glaubt, dass es nichts zu speichern gibt weil ja gar nichts dirty ist.
         * Damit dies nicht passiert, hoeren wir in allen Views auf diesen Event und setzen das Form auf dirty
         */
        this.$scope.$on(TSMessageEvent[TSMessageEvent.ERROR_UPDATE], (event: any, errors: Array<TSExceptionReport>) => {
            console.debug('setting dirty because of ERROR_UPDATE event');
            this.form.$dirty = true;
            this.form.$pristine = false;
        });
    }

    /**
     * Diese Methode prueft ob das Form valid ist. Sollte es nicht valid sein wird das erste fehlende Element gesucht
     * und fokusiert, damit der Benutzer nicht scrollen muss, um den Fehler zu finden.
     * Am Ende wird this.form.$valid zurueckgegeben
     */
    public isModelValid(): boolean {
        if (!this.form.$valid) {
            DVBernUtil.focusFirstInvalidInput()
        }
        return this.form.$valid;
    }

    public onDocAdded(document: TSDokument) {
        //wenn entity noch nicht gespeichert ist
        let modelWithDocs: IHasUnconnectedDocuments | any = this.getModel();
        if (isInstanceOfHasUnconnectedDocuments(modelWithDocs) && this.getModel().isNew()) {
            modelWithDocs.documentIdsToConnect.push(document.id);
        }
    }

    public onDocRemoved(document: TSDokument) {
        //wenn entity noch nicht gespeichert ist
        let modelWithDocs: IHasUnconnectedDocuments | any = this.getModel();
        if (isInstanceOfHasUnconnectedDocuments(modelWithDocs)) {
            if (modelWithDocs.documentIdsToConnect && this.getModel().isNew() && document.id) {
                let index: number = modelWithDocs.documentIdsToConnect.indexOf(document.id);
                if (index > -1) {
                    modelWithDocs.documentIdsToConnect.splice(index, 1);
                }
            }
        }
    }

    get model(): T {
        return this._model;
    }

    set model(value: T) {
        this._model = value;
    }

    public getModel(): T {
        return this._model;
    }

    get initialModel(): T {
        return this._initialModel;
    }

    set initialModel(value: T) {
        this._initialModel = value;
    }

}



// WEBPACK FOOTER //
// ./src/app/gesuch/component/abstractModelController.ts